module.exports = __webpack_public_path__ + "static/logo-114824da3705d6fb9de3a43450efcd0b.png";